import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formattedlist',
    pure: true,
    standalone: false
})
export class FormattedListPipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    return value;
  }
}
